import { syncState } from "@legendapp/state";
import type { LanesConfig } from "@repo/lanes";
import { toast } from "sonner";

import { trpc } from "~/libs/trpc.lib";
import { datasources$ } from "./datasources.crud";

export const testDatasource = async (input: LanesConfig) => {
  return await trpc.datasources.testConnection.mutate(input);
};

/**
 * Lists the schemas available on a connection from raw credentials, used by
 * the datasource-creation schema picker. Returns every schema on the
 * connection, ignoring any configured-schema scoping.
 */
export const listDatasourceSchemas = async (input: LanesConfig) => {
  return await trpc.datasources.listSchemas.mutate(input);
};

export const createDatasource = async (
  input: Parameters<typeof trpc.datasources.create.mutate>[0],
) => {
  const result = await trpc.datasources.create.mutate(input);
  // Sync the datasources list to get the new datasource
  await syncState(datasources$).sync();
  return result;
};

export const testExistingConnection = async (datasourceId: string) => {
  return await trpc.datasources.testExistingConnection.mutate({
    datasourceId,
  });
};

/** Triggers exploration for a datasource and optimistically sets the status to QUEUED. */
export const exploreDatasource = async (datasourceId: string) => {
  try {
    datasources$[datasourceId].explorationStatus.set("QUEUED");
    await trpc.datasources.explore.mutate({ datasourceId });
    toast.success("Exploration started — knowledge will update shortly");
  } catch (error) {
    toast.error(
      error instanceof Error ? error.message : "Failed to start exploration",
    );
  }
};
